module.exports = __webpack_public_path__ + "img/6.089a8827.png";